/**
 * Идентификатор процесса предпросмотра
 */
export const START_PREVIEW_FEED_STRING_NAME_PROCESS: string = 'startPreview';